
import { defineComponent, PropType } from "vue";
import InfoIconSvgVue from "../svg/InfoIconSvg.vue";
import WarningIconSvgVue from "../svg/WarningIconSvg.vue";
import DangerIconSvgVue from "../svg/DangerIconSvg.vue";

export default defineComponent({
  components: {
    appWarningIcon: WarningIconSvgVue,
    appInfoIcon: InfoIconSvgVue,
    appDangerIcon: DangerIconSvgVue,
  },
  props: {
    dismiss: Function,
    mode: {
      type: String as PropType<
        "normal" | "info" | "warning" | "danger" | "success"
      >,
      default: "normal",
    },
    variant: {
      type: String as PropType<"contained" | "outlined">,
      default: "contained",
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    icon() {
      if (!this.showIcon) {
        return null;
      }
      let icon: string | null = null;

      switch (this.mode) {
        case "normal":
          // no icon
          break;
        case "info":
          icon = "app-info-icon";
          break;
        case "warning":
          icon = "app-warning-icon";
          break;
        case "danger":
          icon = "app-danger-icon";
          break;
      }

      return icon;
    },
  },
});
